module.exports = __webpack_public_path__ + "static/media/infoTransporte.f63a5d4b.png";